exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.none-border {\n  border: 0;\n  background-color: transparent !important;\n}\n", ""]);

// exports
